import 'react';
import { ITopUpDetails } from '@/modules/credits/models/top-up-details';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StackStyled } from './repartition-top-up.styled';
import { JTable } from '@atoms/JTable';
import { COLUMN_TABLE_REPARTITION_TOP_UPS } from './const';
import RowRepartitionTopUp from './row-repartition-top-up';

interface ConfirmCancelPopUpsProps {
  topUps: ITopUpDetails;
}

const RepartitionTopUp = ({ topUps }: ConfirmCancelPopUpsProps) => {
  const { t } = useTranslation();

  if (topUps.creditsSharing.length === 0) {
    return <></>;
  }

  return (
    <StackStyled>
      <Typography variant="h3">{t('REPARTITIONS')}</Typography>
      <JTable columns={COLUMN_TABLE_REPARTITION_TOP_UPS}>
        {topUps.creditsSharing.map(({ establishment, creditsAmount }) => (
          <RowRepartitionTopUp
            etablishmentName={establishment.name}
            repartition={creditsAmount}
            threshold={establishment.creditsAlertThreshold}
            key={establishment.id}
          />
        ))}
      </JTable>
    </StackStyled>
  );
};

export default RepartitionTopUp;
